'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.program = twentyninetimes.program || function () {

	function init() {
		const programElm = document.getElementById('program');

		if ( programElm ) {
			const programSwitcher 	= document.getElementById('program-switcher'),
				  sliderContainer 	= programElm.querySelector('.program-days'),
				  slides 			= programElm.querySelectorAll('.program-day');

			var btnPrev = programElm.querySelector('.program-btn.previous'),
  				btnNext = programElm.querySelector('.program-btn.next');

			if ( programSwitcher ) {
				switcherFunction(programElm, sliderContainer, slides, programSwitcher, btnPrev, btnNext);
			}

			daySlider(programElm, sliderContainer, slides, btnPrev, btnNext);
		}
	}

	function switcherFunction(programElm, sliderContainer, slides, programSwitcher, btnPrev, btnNext) {
		var radios = programSwitcher.querySelectorAll('input[type="radio"]');

		if ( radios ) {
			radios.forEach((radio) => {
				radio.addEventListener('input', (e) => {
					e.stopPropagation();

					var value = radio.value;

					if ( value == 'day' ) {
						programElm.classList.add('day-active', 'hide-artists');
					} else {
						programElm.classList.remove('day-active');
						sliderContainer.style.transform = 'translate3d(0,0,0)';

			  			btnPrev.classList.add('in-active');
			  			btnNext.classList.remove('in-active');

			  			programElm.querySelector('.program-day.active').classList.remove('active');
			  			slides[0].classList.add('active');
					}
				});
			});
		}
	}

	function daySlider(programElm, sliderContainer, slides, btnPrev, btnNext) {
		const sliderBtns = programElm.querySelectorAll('.program-btn');

		var currentSlide = 0;

		if ( sliderBtns ) {
			sliderBtns.forEach((btn) => {
				btn.addEventListener('click', (e) => {
					e.stopPropagation();

					var slideActive = programElm.querySelector('.program-day.active'),
						slideIndex = slideActive.getAttribute('data-slide');

					currentSlide = slideIndex;

					if ( btn.classList.contains('previous') && slideIndex == 0 ) return;
					if ( btn.classList.contains('next') && slideIndex == slides.length - 1 ) return;

					( btn.classList.contains('previous') )
						? currentSlide--
						: currentSlide++;

					slideActive.classList.remove('active');
					slides[currentSlide].classList.add('active');

					var scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop),
	                	elmnt_scrollTop = scrollTop + programElm.getBoundingClientRect().top - 100;
					
					scrollTo(elmnt_scrollTop, 1000);

					var transform = 100 * currentSlide;
					sliderContainer.style.transform = `translate3d(-${(transform)}%,0,0)`;

					slideActive = programElm.querySelector('.program-day.active');
					slideIndex = slideActive.getAttribute('data-slide');

					( slideIndex == 0 )
						? btnPrev.classList.add('in-active')
						: btnPrev.classList.remove('in-active');

					( slideIndex == slides.length - 1 )
						? btnNext.classList.add('in-active')
						: btnNext.classList.remove('in-active');
				});
			});
		}
	}

	function dayTopSticky(movingElements) {
		if ( !movingElements ) return;

		// Loop over each moving element
		movingElements.forEach(function(movingElement) {
			// Get the container of the moving element
			var container = movingElement.parentElement;

			// Calculate the top position relative to the window
			var topPosition = window.innerWidth > 767
				? window.pageYOffset + 110
				: window.pageYOffset + 90;

			// Calculate the top and bottom position of the container
			var containerTop = container.getBoundingClientRect().top + window.pageYOffset;
			var containerBottom = container.getBoundingClientRect().bottom + window.pageYOffset;

			// If the scroll position is greater than the top position of the moving element and the container's bottom position is still in the viewport, make the element sticky
			if (topPosition > containerTop && topPosition < containerBottom - movingElement.offsetHeight) {
				movingElement.style.transform = `translateY(${topPosition - containerTop}px)`;
			} 
			// If the scroll position is greater than the bottom position of the container, stop the element at the bottom of the container
			else if (topPosition > containerBottom - movingElement.offsetHeight) {
				movingElement.style.transform = `translateY(${containerBottom - containerTop - movingElement.offsetHeight}px)`;
			} 
			// If the scroll position is less than the top position of the container, reset the element's position
			else {
				movingElement.style.transform = 'translateY(0)';
			}
		});
	}

	return {
		init : init,
		dayTopSticky : dayTopSticky
	};

}();

var scrollTo = function(to, duration) {
    var	element = document.scrollingElement || document.documentElement,
        start = element.scrollTop,
        change = to - start,
        startDate = +new Date(),
        // t = current time
        // b = start value
        // c = change in value
        // d = duration
        easeInOutQuart = function(t, b, c, d) {
            t /= d/2;
        	if (t < 1) return c/2*t*t*t*t + b;
        	t -= 2;
        	return -c/2 * (t*t*t*t - 2) + b;
        },
        animateScroll = function() {
            var currentDate = +new Date();
            var currentTime = currentDate - startDate;
            element.scrollTop = parseInt(easeInOutQuart(currentTime, start, change, duration));
            if(currentTime < duration) {
                requestAnimationFrame(animateScroll);
            }
            else {
                element.scrollTop = to;
            }
        };
        
    animateScroll();
};